export enum EventType {
	HIT = 'hit',
	CLICK = 'click',
	VIEW = 'view',
}
